module.exports = __webpack_public_path__ + "static/media/599.7554(19).c1475fa9.pdf";